import { useAuth } from '../contexts/AuthContext';
import { canView as canViewFn, canWrite as canWriteFn, canCreate as canCreateFn, canUpdate as canUpdateFn, canDelete as canDeleteFn } from '../utils/permissions';

// Read the current user's module permissions inside React components.
// canWrite(module) is true for SUPERADMIN/ADMIN or when the user has any of
// create/update/delete on that module; canView/canCreate/canUpdate/canDelete are the
// granular per-capability checks (view / add / edit / delete).
export const usePermissions = () => {
  const { user } = useAuth();
  return {
    canView: (moduleName: string) => canViewFn(user, moduleName),
    canWrite: (moduleName: string) => canWriteFn(user, moduleName),
    canCreate: (moduleName: string) => canCreateFn(user, moduleName),
    canUpdate: (moduleName: string) => canUpdateFn(user, moduleName),
    canDelete: (moduleName: string) => canDeleteFn(user, moduleName),
  };
};

export default usePermissions;
